/**
 * Helper function to detect if the current window is running inside an IFrame
 * @returns true if the window is in an IFrame, false otherwise
 */
export function isInIFrame(): boolean {
  try {
    return window.self !== window.top;
  } catch (e) {
    // Cross-origin access to window.top will throw an error
    // This typically means we are in an IFrame with cross-origin restrictions
    return true;
  }
}
